export default function MetricCard({ label, value, sublabel, accent = "default" }) {
  const accents = {
    default: "",
    blue: "border-l-4 border-l-brand-blue",
    orange: "border-l-4 border-l-brand-orange",
    mint: "border-l-4 border-l-brand-mint",
    green: "border-l-4 border-l-emerald-500",
    red: "border-l-4 border-l-red-500",
    amber: "border-l-4 border-l-amber-500",
  };
  return (
    <div className={`bg-white dark:bg-[var(--bg-surface)] rounded-xl border border-gray-100 dark:border-[var(--border-soft)] shadow-card p-4 ${accents[accent]}`}>
      <div className="text-xs font-medium uppercase tracking-wide text-brand-slate">{label}</div>
      <div className="mt-1.5 font-display font-semibold text-xl text-brand-ink dark:text-[var(--text-primary)]">{value}</div>
      {sublabel && <div className="mt-0.5 text-xs text-brand-slate">{sublabel}</div>}
    </div>
  );
}